<div class="db-ecommerce-complete-setup db-platform-account-upgraded">
  <h2 [innerHTML]="'text_ecommerceCompleteSetupTitleNew' | dbText"></h2>
  <p [innerHTML]="'Almost done! Complete your website details to finish setup.'"></p>
  <form [formGroup]="createWebsiteForm" (ngSubmit)="submit()">
    <!-- submit form with Enter
    <button [disabled]="loading" type="submit" style="display:none">hidden submit</button>-->
    <div class="ds-input-wrap static mb30">
      <span class="ds-input-label">Website title</span>
      <input type="text" class="ds-input" [class.error]="formSubmitted && createWebsiteForm?.get('websiteTitle')?.errors"
             placeholder="Your website title" maxlength="255" formControlName="websiteTitle">
      <span *ngIf="formSubmitted && createWebsiteForm?.get('websiteTitle')?.errors" class="ds-input-error-msg"
            [innerHTML]="createWebsiteForm?.get('websiteTitle')?.errors['required'] ?
            'This field is required.' : ''"></span>
    </div>

    <div class="ds-input-wrap static mb30">
      <span class="ds-input-label">Subdomain
      </span>
      <div class="db-website-install__subdomain">
        <input type="text" class="ds-input mr20" maxlength="56"
               [class.error]="formSubmitted && createWebsiteForm?.get('subdomain')?.errors"
               placeholder="example" formControlName="subdomain">
        <span>.{{configHostname}}</span>
      </div>
      <span class="db-mobile-hint">{{ 'text_subDomainDescription' | dbText}}</span>
      <span *ngIf="formSubmitted && createWebsiteForm?.get('subdomain')?.errors" class="ds-input-error-msg"
            [innerHTML]="createWebsiteForm?.get('subdomain')?.errors['required'] ?
            'This field is required.':
            createWebsiteForm?.get('subdomain')?.errors?.pattern ? ('text_fillFieldAllowedLetters' | dbText) :
            createWebsiteForm?.get('subdomain')?.errors?.taken ? createWebsiteForm?.get('subdomain')?.errors?.taken
            : ''"></span>
    </div>

    <div class="ds-input-wrap static mb30" *ngIf="regions && regions?.length">
      <ds-dropdown [dsDropdownOptions]="regions"
                   formControlName="region"
                   [dsDropdownLabel]="('text_regionDescriptionOther' | dbText)"
                   [dsDropdownDisabled]="subscription?.isDedicatedVM"
      ></ds-dropdown>
      <span class="db-mobile-hint">Choose the location based on your traffic.</span>
    </div>

  </form>
    <div class="db-platform-account-upgraded__buttons-wrap text-center mt30">
      <button class="ds-btn-black ds-btn-max rectangle" (click)="submit()"><span>Proceed</span></button>
    </div>
</div>
